<template>
  <div id="outInform" class="page-content">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>{{logintype=='SHOP'||logintype=='DEALER'?"违规举报":'违规处理'}}</el-breadcrumb-item>
      <el-breadcrumb-item>违规信息举报</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-tabs type="card" v-model="activeName" v-if="logintype=='KEFU'">
        <el-tab-pane :label="item.label" :name="item.name" v-for="item in tabList" :key="item.name">
          <commonForm :activeName="activeName"></commonForm>
        </el-tab-pane>
      </el-tabs>
      <el-tabs type="card" v-model="activeName2" v-if="logintype != 'KEFU'">
        <el-tab-pane :label="item.label" :name="item.name" v-for="item in hcmList" :key="item.name">
          <commonForm :activeName="activeName2"></commonForm>
        </el-tab-pane>
      </el-tabs>
      <!-- <commonForm activeName="first" v-if="logintype != 'HCM' && logintype != 'KEFU'"></commonForm> -->
    </section>
  </div>
</template>

<script>
import { getLoginType } from "@/libs/until";

import commonForm from "./commonForm";
export default {
  name: "outInform",
  data: function() {
    return {
      labelWidth: "150px",
      activeName: "first",
      activeName2: "1",
      tabList: [
        { label: "单条举报", name: "first" },
        { label: "批量举报", name: "second" },
        { label: "匿名违规举报", name: "third" },
        { label: "表格导入", name: "fourth" }
      ],
      hcmList: [
        { label: "违规信息举报", name: "1" },
        { label: "匿名违规举报", name: "2" }
      ],
      logintype: getLoginType()
    };
  },
  components: { commonForm }
};
</script>

<style lang="scss">
#outInform {
  .el-tabs__nav-scroll {
    padding-left: 32px;
  }
  .g-margin-left{
    margin-left: 0;
  }
   .shoptype {
    vertical-align:middle;
  }
  .upload-demo{
    width: 100%;
    float: left;
    text-align: left;
  }
  .link_content {
    width: 425px;
    .el-input {
      width: 400px;
    }
  }
  .screenshot {
    width: 500px;
  }
  .screenshot>div{
    height: auto;
    width: 100%;
  }
  .el-form-item {
    margin-bottom: 16px;
  }
  .el-table__empty-text {
    padding-top: 100px;
    background: url("../../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .seaerch-wrapper {
    // min-height: 766px;
    min-height: 100%;
    width: 100%;
    position: absolute;
    box-sizing: border-box;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 119px;
    height: 119px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    text-align: center;
    margin-top: 32px;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .trumpet_icon_container {
    font-size: 12px;
    color: #faad14;
    background: #fffbf3;
    width: 507px;
    height: 28px;
    line-height: 28px;
    margin-bottom: 20px;
    img {
      width: 14px;
      height: 12px;
      vertical-align: middle;
    }
  }
  .el-input {
    width: 425px;
  }
  .content-warpper {
    .el-input__inner {
      width: 425px;
    }
  }
  .intro {
    font-size: 14px;
    color: #999;
    line-height: 20px !important;
    min-width: 500px;
  }
  .el-textarea__inner,
  .el-textarea {
    width: 425px;
    height: 167px;
  }
}
</style>
